import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import TabNavigation from "components/tablinks/tablinks";
import { Row } from "reactstrap";

const ClientMenu = () => {
  const { t } = useTranslation();

  const navItems = [
    {
      id: "contact-info",
      label: "All Contact Info",
      link: "/client/contact-info",
    },
    {
      id: "subscription",
      label: "Subscription",
      link: "/client/subscription",
    },
     {
      id: "support-ticket",
      label: "Support ticket",
      link: "/client/support-ticket",
    },
     {
      id: "messages",
      label: "Messages",
      link: "/client/messages",
    },
    {
      id: "emails",
      label: "Emails",
      link: "/client/emails",
    },
  ];

  return (
    <React.Fragment>
      <Row className="mb-4">
        <div className="col-12">
          <TabNavigation navItems={navItems} />
          </div>
      </Row>
      
    </React.Fragment>
  );
};

ClientMenu.propTypes = {
  t: PropTypes.any,
};

export default ClientMenu;
